import React, { useState, useEffect, useCallback } from "react";
import Search from "./Search";
import FolderBrowser from "./FolderBrowser";
import Samples from "../Samples";
import { fetchSamples } from "../Utils/SamplesFetch";
import {
  RestrictedWidth,
  Container,
  Body,
  PrimaryHeading,
  FadeIfEmpty,
  HeaderLink
} from "./Theme";

export default function Trending({ company_id, canFindCompany, clientView }) {
  const [folder, setFolder] = useState(null);
  const [sampleList, setSampleList] = useState(null);
  const [loadingSamples, setLoadingSamples] = useState(false);

  const findSamples = useCallback(({ sample_ids }) => {
    setLoadingSamples(true);
    fetchSamples({
      sample_ids
    }).then(sampleList => {
      setLoadingSamples(false);
      setSampleList(null);
      setSampleList(sampleList);
    });
  }, []);

  const updateCharts = folder => {
    setSampleList(null);
    setFolder(folder);
  };

  const clearSample = () => setSampleList(null);

  const renderSampleContainer = () => (
    <div style={{ marginTop: 20, opacity: loadingSamples || !sampleList ? 0.5 : 1 }}>
      <PrimaryHeading>
        Samples
        {sampleList && <HeaderLink onClick={clearSample}>Clear Samples</HeaderLink>}
      </PrimaryHeading>
      <Samples
        sample_list={sampleList}
        company_id={company_id}
        showAttributes={false}
        clientView={clientView === false ? clientView : true}
      />
    </div>
  );

  return (
    <div>
      <RestrictedWidth>
        <Search
          company_id={company_id}
          canFindCompany={canFindCompany}
          onLoad={updateCharts}
          clientView={clientView}
        />
      </RestrictedWidth>
      {folder && (
        <div>
          {sampleList && renderSampleContainer()}
          <FadeIfEmpty empty={!folder}>
            <FolderBrowser folder={folder} findSamples={findSamples} />
          </FadeIfEmpty>
        </div>
      )}
    </div>
  );
}
